import React from 'react';

import {
    FORGOTTEN_CONFIRMATION_MSG_TITLE,
    FORGOTTEN_CONFIRMATION_MSG,
} from '../../../helpers/messageText';

class ForgottenConfirmation extends React.Component {
    onReturnHandler = () => {
        this.props.history.push('/login');
    };

    render() {
        return (
            <div>
                {/* <!-- Form --> */}
                <div className="mt-3">
                    <p className="alert alert-success mt-4" role="alert">
                        <strong>{FORGOTTEN_CONFIRMATION_MSG_TITLE}</strong>
                        <br />
                        {FORGOTTEN_CONFIRMATION_MSG}
                    </p>
                </div>
                {/* <!-- Items below Form --> */}
                <div className="">
                    <hr />
                    <div className="row justify-content-center pl-3 pr-3 pb-2">
                        <a
                            onClick={this.onReturnHandler}
                            className="col-sm-8 btn btn-outline-primary no-outline"
                        >
                            Return to Sign in
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default ForgottenConfirmation;



// WEBPACK FOOTER //
// ./src/containers/PublicArea/components/ForgottenConfirmation.js